module.exports = __webpack_public_path__ + "img/mxjs_nav.543c5baa.png";